import gql from 'graphql-tag';

export default gql`
  fragment hubspotDealCreateActivityFragment on HubspotDealCreateActivity {
    hubspotDealId
  }
`;
